import angular from 'angular';


import OfficeProfileController from './officeProfileController';

import './additionalServices/additionalServices.scss';
import './counties/counties.scss';
import './logoUpload/logoUpload.scss';

export default angular.module('app.accounts.offices.profile', [])
    .controller('OfficeProfileController', OfficeProfileController)

    .run(($templateCache) => {
        $templateCache.put('app/accounts/offices/profile/additionalServices/additionalServices.html', require('./additionalServices/additionalServices.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/profile/editProfile.html', require('./editProfile.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/profile/officeProfile.html', require('./officeProfile.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/profile/viewProfile.html', require('./viewProfile.html')); // eslint-disable-line global-require


        $templateCache.put('app/accounts/offices/profile/additionalServices/viewProfile.html', require('./viewProfile.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/profile/counties/counties.html', require('./counties/counties.html')); // eslint-disable-line global-require
        $templateCache.put('app/accounts/offices/profile/logoUpload/logoUpload.html', require('./logoUpload/logoUpload.html')); // eslint-disable-line global-require
    })

    .name;



// WEBPACK FOOTER //
// ./src/app/accounts/offices/profile/index.js